import { provideSvgSprites } from 'ngxtension/svg-sprite';

export function provideSprites() {
  return provideSvgSprites({
    name: 'icons',
    baseUrl: '/assets/sprites/icons.svg?v=5',
  });
}
